<template>
  <div class="container">
    <div class="right">
      <el-row>
        <el-col :span="4">
          <el-input size="small" clearable placeholder="任务名" prefix-icon="el-icon-search" v-model="search.task_name"
            @clear="clearKeyword">
          </el-input>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-input size="small" clearable placeholder="用户手机号" prefix-icon="el-icon-search" v-model="search.mobile"
            @clear="clearKeyword">
          </el-input>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-button type="primary" size="small" @click="logList">搜索</el-button>
        </el-col>
      </el-row>
      <div class="distance">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="序号"></el-table-column>
          <el-table-column prop="task.name" label="任务ID"></el-table-column>
          <el-table-column prop="task.desc" label="任务描述"></el-table-column>
          <el-table-column prop="user.mobile" label="关联用户"></el-table-column>
          <el-table-column prop="status" label="结果">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 1" type="success">成功</el-tag>
              <el-tag v-else type="danger">失败</el-tag>
              &nbsp;
              <template v-if="scope.row.status == 0">
                <el-tooltip :content="scope.row.remark" placement="top">
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间"></el-table-column>
        </el-table>
      </div>
      <pagingVue :Pagination="Pagination" :tableData="tableData" @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange">
      </pagingVue>
    </div>
  </div>
</template>
<script>
import pagingVue from "../../components/Paging/paging.vue";

export default {
  name: "Promo_task_log",
  data() {
    return {
      search: {
        task_name: "",
        mobile: "",
        page: "",
      },
      Pagination: {},
      tableData: []
    };
  },
  components: {
    pagingVue
  },
  activated() {
    this.logList();
  },
  methods: {
    clearKeyword() {
      this.logList();
    },
    async logList() {
      await this.$axios
        .getListData("admin/promo/task-logs", this.search)
        .then((res) => {
          if (res.code === 200) {
            this.Pagination = res.data.meta.pagination;
            let logData = res.data.data;
            this.tableData = logData.map((v) => {
              return {
                ...v,
                created_at: this.$inserted(v.created_at),
              };
            });
          }
        });
    },
    // 分页
    handleSizeChange(val) {
      this.Pagination.per_page = val;
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.logList();
    }
  },
};
</script>
<style lang="less" scoped>
/deep/.cell {
  max-height: 28px !important;
}

/deep/.el-table__empty-text {
  line-height: 53px;
}

/deep/.el-table__empty-block {
  min-height: 53px;
}

/deep/.el-dialog__body {
  padding: 20px;
}

/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #909399;
  display: none;
}

/deep/.el-message-box__headerbtn .el-message-box__close {
  display: none;
  color: #909399;
}

/deep/.el-button--text {
  font-size: 18px;
  margin-top: -8px;
}

/deep/.el-table__body {
  width: 100% !important;
}

/deep/.el-select {
  width: 100% !important;
}

/deep/.el-form-item {
  margin-bottom: 12px;
}

/deep/.el-radio-group {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.dialog-footer {
  display: flex !important;
  justify-content: space-around !important;
}

.container {
  width: 100%;
  box-sizing: border-box;
  padding: 30px;
  overflow: hidden;

  .right-item {
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .distance {
    margin: 10px 0;
  }

  .right {
    .flex-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .flex {
      display: flex;
      align-items: center;
    }
  }

  /deep/.el-dialog__body {
    padding: 20px !important;
  }
}
</style>
    